/**
 *
 *  Need to export window from here instead of using global window object. It makes writing unit tests easier as we can mock window.ts module, instead of mocking global window object.
 * We can also use this module to export other global objects in the future..
 *
 *  */
export const w = window;
